import { saveAs } from "file-saver";

const http = <T>(url: string, request: RequestInit): Promise<HttpResponse<T>> => {
    // TODO: Fix this, temporary solution
    if (url.startsWith("/")) {
        url = window.location.origin + url;
    }

    return new Promise((resolve, reject) => {
        let response: HttpResponse<T>;
        fetch(url, request)
            .then((res) => {
                response = res;
                return res.json();
            })
            .then((body) => {
                if (response.ok) {
                    response.parsedBody = body;
                    resolve(response);
                } else {
                    response.parsedError = body;
                    reject(response);
                }
            });
    });
};

export const httpDownload = <T>(url: string, request: RequestInit, name = "unknown"): Promise<HttpResponse<T>> => {
    return new Promise((resolve, reject) => {
        let response: HttpResponse<T>;

        fetch(url, request)
            .then((res) => {
                response = res;

                return res.blob();
            })
            .then((file) => {
                if (response.ok) {
                    const contentDispositionValue = response.headers.get("content-disposition");

                    const fileName = contentDispositionValue
                        ? contentDispositionValue
                              .split(";")
                              .find((n) => n.includes("filename="))
                              ?.replace("filename=", "")
                              .trim()
                        : name;

                    saveAs(file, fileName?.replaceAll('"', ""));
                    resolve(response);
                } else {
                    reject(response);
                }
            });
    });
};

export async function post<T>(
    path: string,
    // eslint-disable-next-line
    body: any,
    args?: RequestInit,
    stringify = true
): Promise<HttpResponse<T>> {
    const request = {
        method: "POST",
        body: body ? (stringify ? JSON.stringify(body) : body) : undefined,
        ...args,
    };

    return await http<T>(path, request);
}

// eslint-disable-next-line
export async function put<T>(path: string, body?: any, args?: RequestInit, stringify = true): Promise<HttpResponse<T>> {
    const request: RequestInit = {
        method: "PUT",
        body: body ? (stringify ? JSON.stringify(body) : body) : undefined,
        ...args,
    };

    return await http<T>(path, request);
}

export async function patch<T>(
    path: string,
    // eslint-disable-next-line
    body?: any,
    args?: RequestInit,
    stringify = true
): Promise<HttpResponse<T>> {
    const request: RequestInit = {
        method: "PATCH",
        body: body ? (stringify ? JSON.stringify(body) : body) : undefined,
        ...args,
    };

    return await http<T>(path, request);
}

export async function remove<T>(path: string, args?: RequestInit): Promise<HttpResponse<T>> {
    const request: RequestInit = {
        method: "DELETE",
        ...args,
    };

    return await http<T>(path, request);
}

export async function get<T>(path: string, args?: RequestInit): Promise<HttpResponse<T>> {
    const request: RequestInit = {
        method: "GET",
        ...args,
    };

    return await http<T>(path, request);
}

export async function downloadFile<T>(path: string, args?: RequestInit): Promise<HttpResponse<T>> {
    const request: RequestInit = {
        method: "GET",
        ...args,
    };

    return await httpDownload<T>(path, request);
}

export const buildUrlWithQueryParams = (url: string, paramsString: string) => {
    // TODO: Fix this, temporary solution
    if (url.startsWith("/")) {
        url = window.location.origin + url;
    }

    const newUrl = new URL(url);
    newUrl.search = new URLSearchParams(paramsString).toString();

    return newUrl.toString();
};

// eslint-disable-next-line
export const buildQueryParams = (params: { [key: string]: any }) => {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        if (params[key]) {
            urlParams.append(key, params[key]);
        }
    });

    return urlParams;
};

export const API = {
    baseApiUrl: process.env.REACT_APP_SERVER_API_ADDRESS,
    xServerUrl: process.env.REACT_APP_XSERVER_ADDRESS,
    serverUrl: process.env.REACT_APP_SERVER_ADDRESS,
};
